import { render, staticRenderFns } from "./StyleDialogLabelsTab.vue?vue&type=template&id=6ba1e90b&scoped=true&"
import script from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogLabelsTab.vue?vue&type=style&index=0&id=6ba1e90b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1e90b",
  null
  
)

export default component.exports